import { CPF_LENGTH } from './constants';

export function stripCpfMask(value: string): string {
  if (!value) {
    return '';
  }

  return value.replace(/\D/g, '');
}

export function isValidCpf(value: string): boolean {
  const cpf = stripCpfMask(value);

  if (cpf.length !== CPF_LENGTH || /^(\d)\1+$/.test(cpf)) {
    return false;
  }

  let sum = 0;
  for (let index = 1; index <= 9; index++) {
    sum += Number.parseInt(cpf[index - 1], 10) * (11 - index);
  }

  let remainder = (sum * 10) % 11;
  if (remainder === 10) {
    remainder = 0;
  }

  if (remainder !== Number.parseInt(cpf[9], 10)) {
    return false;
  }

  sum = 0;
  for (let index = 1; index <= 10; index++) {
    sum += Number.parseInt(cpf[index - 1], 10) * (12 - index);
  }

  remainder = (sum * 10) % 11;
  if (remainder === 10) {
    remainder = 0;
  }

  return remainder === Number.parseInt(cpf[10], 10);
}

export function formatCpf(value: string): string {
  const cpf = stripCpfMask(value);

  if (cpf.length !== CPF_LENGTH) {
    return value;
  }

  return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
}
